import { useLazyQuery, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import pack from "../../../../package.json";
import { getCurrentVersion } from "../../../Utils/AllPagesQuriesAndMutations";

export const useAppVersionChecker = (setIsLatest) => {
  const location = useLocation();
  const [message, setMessage] = useState(null);

  const [getLatestVersionOfErp] = useLazyQuery(getCurrentVersion, {
    fetchPolicy: "network-only",
  });
    const {data} = useQuery(getCurrentVersion, {
    fetchPolicy: "network-only",
    onCompleted:(res)=>{

    }
  });

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // const { data } = await getLatestVersionOfErp();
        const latestVersion = data?.get_Latest_Version?.Version_List_Erp_App;
    

        if (!latestVersion) return;

        if (latestVersion !== pack.version && location.pathname !== "/") {
          setIsLatest(true);
          setMessage(`Available version is ${latestVersion}. Please refresh to get the latest features.`);
        }
      } catch (error) {
        console.error("Version check failed", error);
      }
    };

    checkVersion();
  }, [location.pathname,]); // run on route change

  return message;
};
